import styled from 'styled-components'

const Logo = styled.img`
  height: 100%;
  cursor: ${props => props.onClick && 'pointer'};
`

export default Logo
